export default __webpack_public_path__ + "cb5a44960e5e2e4203040a168b90489c.svg";